import type { CircularProgressProps } from "@mui/material";
import { CircularProgress, styled } from "@mui/material";
import { forwardRef } from "react";


export const CentredSpinnerRoot = styled("div")`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;

export const CentredSpinner = forwardRef<HTMLDivElement, CircularProgressProps>((props, ref) => (
	<CentredSpinnerRoot ref={ ref }>
		<CircularProgress { ...props }/>
	</CentredSpinnerRoot>
));
